import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
    combineClasses,
} from 'wanderu-css';

import {
    CheckIcon,
    ErrorIcon,
    InfoIcon,
} from '../Icons';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Alert.scss';

const iconMap = {
    error: ErrorIcon,
    info: InfoIcon,
    success: CheckIcon,
    warning: ErrorIcon,
};

function Alert(props) {
    const {
        classes: classesProp = {},
        className,
        children,
        variant = 'info',
        ...otherProps
    } = props;
    const classes = combineClasses(styles, classesProp);
    const Icon = iconMap[variant];

    return (
        <div
            className={classnames(
                classes.container,
                classes[variant],
                className,
            )}
            {...otherProps}
        >
            <span className={classes.icon}>
                <Icon />
            </span>
            <div className={classes.content}>
                {children}
            </div>
        </div>
    );
}

Alert.propTypes = {
    /**
     * The content of the toast.
     */
    children: PropTypes.node,
    /**
     * Override or extend the styles applied to the component.
     */
    classes: PropTypes.object,
    /**
     * @ignore
     */
    className: PropTypes.string,
    role: PropTypes.string,
    /**
     * Used to control the toast styling.
     */
    variant: PropTypes.oneOf(['info', 'warning', 'success', 'error']),
};

export default Alert;
